import styled from "styled-components";

export const StyledImagesPage = styled.div``;